export var EventSnapType;
(function (EventSnapType) {
    EventSnapType[EventSnapType["Beat"] = 0] = "Beat";
    EventSnapType[EventSnapType["HalfBeat"] = 1] = "HalfBeat";
    EventSnapType[EventSnapType["QuarterBeat"] = 2] = "QuarterBeat";
    EventSnapType[EventSnapType["EighthBeat"] = 3] = "EighthBeat";
    EventSnapType[EventSnapType["None"] = 4] = "None";
})(EventSnapType || (EventSnapType = {}));
export var TimelineMode;
(function (TimelineMode) {
    TimelineMode[TimelineMode["Playback"] = 0] = "Playback";
    TimelineMode[TimelineMode["Edit"] = 1] = "Edit";
})(TimelineMode || (TimelineMode = {}));
export var MouseClickType;
(function (MouseClickType) {
    MouseClickType[MouseClickType["LeftClick"] = 0] = "LeftClick";
    MouseClickType[MouseClickType["RightClick"] = 1] = "RightClick";
    MouseClickType[MouseClickType["MiddleClick"] = 2] = "MiddleClick";
    MouseClickType[MouseClickType["None"] = 3] = "None";
})(MouseClickType || (MouseClickType = {}));
export var NoteLength;
(function (NoteLength) {
    NoteLength[NoteLength["Whole"] = 0] = "Whole";
    NoteLength[NoteLength["Half"] = 1] = "Half";
    NoteLength[NoteLength["Quarter"] = 2] = "Quarter";
    NoteLength[NoteLength["Eighth"] = 3] = "Eighth";
    NoteLength[NoteLength["Sixteenth"] = 4] = "Sixteenth";
    NoteLength[NoteLength["ThirtySecond"] = 5] = "ThirtySecond";
})(NoteLength || (NoteLength = {}));
//# sourceMappingURL=Enums.js.map